import { render, staticRenderFns } from "./admin-partner.vue?vue&type=template&id=40695732&scoped=true&"
import script from "./admin-partner.vue?vue&type=script&lang=js&"
export * from "./admin-partner.vue?vue&type=script&lang=js&"
import style0 from "./admin-partner.vue?vue&type=style&index=0&id=40695732&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40695732",
  null
  
)

export default component.exports